// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__r6il-","options":"AnswerScale_options__2QYf6","selected":"AnswerScale_selected__1BHOF"};